import { createApp, ref } from 'vue/dist/vue.esm-bundler.js';
import { store } from '../store.js';
import 'lazysizes';
import Quiz from '../components/Quiz.vue';
import QuizAudioPlayer from '../components/quiz/QuizAudioPlayer.vue';
import axios from 'axios';

const Course = {
    elements: {
        $accordionTrigger: null,
        $lesson: null,
    },
    data: {
        lessonId: null,
        lessonType: null,
        completedLessons: [],
        userId: null,
        token: null
    },
    init() {
        const self = this;
        // Initialize our properties
        self.elements.$accordionTrigger = document.querySelectorAll('.js-accordion-trigger');
        self.elements.$lesson = document.querySelector('article.js-lesson');
        self.data.userId = store.userId;

        // Init the accordions
        self.accordionTrigger();

        // Get this Lesson's ID
        if (self.elements.$lesson) {
            self.data.lessonId = self.elements.$lesson.dataset.lessonId;
            self.data.lessonType = self.elements.$lesson.dataset.type;
        }

        if (self.data.userId) {
            let checks = document.querySelectorAll('#course-navigation li.lesson[data-completed]');
            let lessons = [];

            checks.forEach((check) => {
                lessons.push(check.dataset.lessonId);
            });

            self.data.completedLessons = lessons;
        } else {
            // Otherwise, get completed modules from localStorage
            self.data.completedLessons = JSON.parse(localStorage.getItem('completedLessons')) || [];
            self.updateChecks();
        }

        // Get the CSRF token
        self.getToken();

        // Add the scroll listener for detecting "lesson completion" to NON-Quiz pages
        let scrollToComplete = true;
        if (self.data.lessonType == 'quizPage') {
            /* If this is a Quiz, check if it's Graded or not.
                For Graded Quizzes, they only get checked off in the sidebar
                once they've been Passed. For Ungraded Quizzes, they get check
                off via scroll like non-Quiz pages.
            */
            let quizWrapper = document.querySelector('.quiz-wrapper');
            let quizIsGraded = quizWrapper ? quizWrapper.dataset.graded == 'graded' : false;
            if (quizIsGraded) {
                scrollToComplete = false;
            }
        }
        if (scrollToComplete) {
            window.addEventListener('scroll', function() {
                self.checkLessonScroll(self.elements.$lesson);
            });
        }
    },
    accordionTrigger() {
        const self = this;

        if (!self.elements.$accordionTrigger) {
            return;
        }

        self.elements.$accordionTrigger.forEach(($trigger) => {
            $trigger.addEventListener('click', function() {
                const targetId = this.dataset.id;
                const $targets = document.querySelectorAll(`.js-accordion-target[data-id="${targetId}"]`);

                if ($targets) {
                    $targets.forEach(($target) => {
                        $target.classList.toggle('is-active');
                        $trigger.classList.toggle('is-active');
                        $trigger.classList.toggle('is-open');
                        // If the trigger is a <details> element, toggle the open attribute
                        $target.open = !$target.open;
                    });
                }
            });
        });
    },
    updateChecks() {
        let ids = this.data.completedLessons;

        // First, get each checkbox item
        const checkboxParents = document.querySelectorAll('#course-navigation .course-checkbox-parent');

        // Then, get the first checkbox to later clone/append it to the newly-checked Lesson checkbox parent
        const checkboxItem = document.querySelector('.course-checkbox-icon');

        checkboxParents.forEach((box) => {
            let thisId = box.dataset.childLesson;

            // If this parent represents a completed Lesson from the saved progress record or local storage...
            if (ids.includes(thisId)) {
                // Don't add another checkbox if it already has one
                let existingCheckbox = box.querySelector('.course-checkbox-icon');

                if (!existingCheckbox) {
                    // Otherwise, create the checkbox node and add it to this parent
                    let newCheckbox = checkboxItem.cloneNode(true);
                    box.appendChild(newCheckbox);
                }
            }
        });
    },
    removeQuizCheck() {
        // Get the checkbox parent with the same lesson ID as this lesson
        let targetBox = document.querySelector('.course-checkbox-parent[data-child-lesson="' + this.data.lessonId + '"]');

        if (targetBox) {
            // Get the checkbox for this lesson, which must always be a Quiz page (assumed)
            const checkboxItem = targetBox.querySelector('.course-checkbox-parent span.course-checkbox-icon');
            checkboxItem.remove();
        }
    },
    updateQuizCheck() {
        // Get the checkbox parent with the same lesson ID as this lesson
        let targetBox = document.querySelector('.course-checkbox-parent[data-child-lesson="' + this.data.lessonId + '"]');

        if (targetBox) {
            // Get the first checkbox to later clone/append it to the newly-checked Lesson checkbox parent
            const checkboxItem = document.querySelector('.course-checkbox-icon');
            // Create the checkbox node and add it to this parent
            let newCheckbox = checkboxItem.cloneNode(true);
            targetBox.appendChild(newCheckbox);
        }
    },
    getToken() {
        axios.get('/actions/blitz/csrf/token')
        .then((response) => {
            this.data.token = response.data;
        });
    },
    checkLessonScroll(lesson) {
        const self = this;

        if (!lesson) {
            return;
        }

        const lessonHeight = lesson.scrollHeight;
        const lessonOffset = lesson.offsetTop;
        const lessonScroll = window.scrollY;
        const lessonPosition = lessonOffset + lessonHeight;
        let complete = false;

        // If the scroll position is at the bottom of the lesson...
        if (complete == false && lessonPosition <= lessonScroll + window.innerHeight) {
            complete = true;
            const lessonId = lesson.dataset.lessonId;
            const userId = self.data.userId;

            // Add this lesson to the completed lessons IF it's not already there
            if (!self.data.completedLessons.includes(lessonId)) {
                // Add this lesson to the completed lessons
                self.data.completedLessons.push(lessonId);

                // Determine if we update localStorage or save it via controller action
                if (userId) {
                    // If there IS a User, update their course progress record with this Lesson
                    const url = new URL(window.location.origin);
                    let params = {
                        'lessonId': lessonId,
                        'userId': userId
                    };
                    const endpoint = `${url}courses/update-course-progress`;
                    const config = {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'multipart/form-data',
                            'Access-Control-Allow-Origin': url,
                            'X-CSRF-Token': self.data.token
                        }
                    };
                    axios.post(endpoint, params, config)
                    .then((response) => {
                        if (response.data.success) {
                            if (Array.isArray(response.data.completedPageIds)) {
                                self.data.completedLessons = response.data.completedPageIds.map(String);
                            }
                            localStorage.setItem('completedLessons', JSON.stringify(self.data.completedLessons));
                        }
                    })

                } else {
                    // If there's no logged-in User, just update the localStorage
                    localStorage.setItem('completedLessons', JSON.stringify(self.data.completedLessons));
                }

                // Check it off in the sidebar
                self.updateChecks();
            }
        }
    }
};

let main = document.querySelector('main');
let hasBlitz = main.dataset.hasBlitz;

if (hasBlitz == 'no-blitz') {
    const event = new Event('afterBlitzInjectAll');
    document.dispatchEvent(event);
}

/* Init our un-cache-able components */
document.addEventListener('afterBlitzInjectAll', function (event) {
    Course.init();
    window.Course = Course;

    document.querySelectorAll('.js-quiz').forEach((el) => {
        const app = createApp({
            components: { Quiz },
            mounted() {
                lazySizes.init();
            }
        }).mount(el);
    });

    document.querySelectorAll('.js-vue-audio-player:not(.is-initialized)').forEach((el) => {

        const app = createApp({
            components: { QuizAudioPlayer },
            mounted() {
                // Remove the skeleton after the audio player has loaded
                const skeleton = el.querySelector('.js-audio-skeleton');
                if (skeleton) {
                    skeleton.remove();
                }

                el.classList.add('is-initialized');
            }
        }).mount(el);
    });
});

// Listen for the "passed Quiz" event from the Quiz vue component
// to update the course progress sidebar
document.addEventListener('quizPassed', function(event) {
    Course.updateQuizCheck();
});

// Listen for the "retake Quiz" event from the Quiz Grade vue component
// to remove the check from the course progress sidebar
document.addEventListener('quizReset', function(event) {
    Course.removeQuizCheck();
});
